module.exports = __webpack_public_path__ + "img/219-2c7359.png";